const base64decode = el => {
    const encodedHref = el.getAttribute("data-href");
    const encodedText = el.getAttribute("data-text");

    if (encodedHref) {
        try {
            el.setAttribute("href", atob(encodedHref));
        } catch (e) {
            console.error("Invalid base64 in data-href", e);
        }
    }

    if (encodedText) {
        try {
            el.textContent = atob(encodedText);
        } catch (e) {
            console.error("Invalid base64 in data-text", e);
        }
    }
}

export default base64decode;